import axios from 'axios';
import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';

const useImportUploadS3Url = () => {
  const call = useCallback(async (params?: { url: string; file: File }) => {
    const reqUrl = params?.url || '';
    const file = await params?.file.arrayBuffer();
    const headers = {
      headers: {
        'Content-Type': params?.file.type,
      },
    };
    const res = await axios.put(reqUrl, file, headers);
    return res;
  }, []);

  const { execute, isLoading } = useAsync(call, false);

  return { urlExecute: execute, fileUploadLoading: isLoading };
};
export default useImportUploadS3Url;
